import Dashboard from 'pages/Dashboard/Dashboard'

/**
 * Dashboard wrapper that enables normalized statistics mode for the shared dashboard component.
 * Main route is /dashboard.
 */
const DashboardNormalized = () => {
  return <Dashboard useNormalizedApi />
}

export default DashboardNormalized
